import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_OUTSTANDING_BILLS_TOTAL_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { ApiStatusType, GenericApiResponse } from '@shared/utils/api/types';

import type { GetInvoiceOutstandingTotalPayload, GetInvoiceOutstandingTotalResult } from '../types/getAllClusterBills.types';

export const INVOICE_OUTSTANDING_TOTAL = 'InvoiceOutstandingTotal';

interface GetInvoiceOutstandingTotalTransformedResult extends GetInvoiceOutstandingTotalResult {
  message: string;
  status: ApiStatusType;
}

export const getInvoiceOutstandingTotal = (builder: BuilderType) =>
  builder.query<GetInvoiceOutstandingTotalTransformedResult, GetInvoiceOutstandingTotalPayload>({
    keepUnusedDataFor: 0,
    providesTags: [INVOICE_OUTSTANDING_TOTAL],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_OUTSTANDING_BILLS_TOTAL_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetInvoiceOutstandingTotalTransformedResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return {
          ...response.Result,
          message: response.Message,
          status: response.Status,
        } as GetInvoiceOutstandingTotalTransformedResult;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
